module.exports = __webpack_public_path__ + "static/media/sort-arrow-down.be128857.svg";